var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightDecoration = function SvgRightDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57 74.022c-4.542 11.574-12.14 15.95-19.422 13.86s-10.335-13.717-6.819-25.971c3.516-12.254 8.596-18.558 19.55-18.406 8.059 4.341 11.851 15.476 6.69 30.517Z",
    fill: "#53B741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.72 43.463-8.142-1.264 3.259 4.728 6.454.136-1.57-3.6ZM37.253 88.173l-8.183-1.841 13.931-1.897-5.748 3.738Z",
    fill: "#53B741"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.163,
    cy: 64.562,
    rx: 15.903,
    ry: 23.084,
    transform: "rotate(16.009 37.163 64.562)",
    fill: "#9CE58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.163 57.666c-1.243-.315-2.362-.28-3.358.104-.593.228-1.176.615-1.748 1.163-.585.568-.992 1.146-1.22 1.734l7.568 1.921L40.728 64l-7.446-1.89c-.047.153-.088.3-.124.44-.144.57-.227.911-.248 1.024l7.146 1.815-.688 1.408-6.602-1.677c-.12 1.773.322 3.165 1.325 4.176a5.442 5.442 0 0 0 2.569 1.467c1.383.351 2.555.263 3.516-.265l-.58 2.286c-1.034.195-2.11.15-3.226-.134-3.344-.849-5.25-2.814-5.72-5.894-.095-.622-.125-1.354-.093-2.196l-1.697-.431.688-1.409 1.165.296c.057-.316.131-.655.223-1.018a9.84 9.84 0 0 1 .127-.452l-1.454-.37.688-1.407 1.288.327c1.07-2.295 2.705-3.723 4.902-4.283 1.357-.349 2.752-.341 4.188.023 1.376.35 2.457.943 3.245 1.781l-.968 1.951c-.713-.976-1.643-1.61-2.79-1.9Z",
    fill: "#53B741"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.423 68.733C89.39 56.514 82.278 50.234 70.385 46.694c12.01-2.969 18.656-9.934 22.154-22.038 3.265 11.761 9.912 18.613 21.922 21.81C103.15 50.463 96.154 57.2 92.423 68.733ZM58.6 24.898c-1.764-6.887-5.903-10.427-12.822-12.422 6.987-1.673 10.854-5.6 12.89-12.421 1.9 6.629 5.766 10.49 12.754 12.293-6.58 2.252-10.651 6.05-12.822 12.55Z",
    fill: "#CDF2C7"
  })));
};
export default SvgRightDecoration;